import { render, staticRenderFns } from "./IndividualBenefits.vue?vue&type=template&id=0b2610c9&"
import script from "./IndividualBenefits.vue?vue&type=script&lang=js&"
export * from "./IndividualBenefits.vue?vue&type=script&lang=js&"
import style0 from "./IndividualBenefits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports